import React from "react";
import Icon from "./Icon";
export default function Copy(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.25H10.0833C9.07081 8.25 8.25 9.07081 8.25 10.0833V18.3333C8.25 19.3459 9.07081 20.1667 10.0833 20.1667H18.3333C19.3459 20.1667 20.1667 19.3459 20.1667 18.3333V10.0833C20.1667 9.07081 19.3459 8.25 18.3333 8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 13.75H3.66659C3.18036 13.75 2.71404 13.5568 2.37022 13.213C2.02641 12.8692 1.83325 12.4029 1.83325 11.9167V3.66666C1.83325 3.18043 2.02641 2.71412 2.37022 2.3703C2.71404 2.02648 3.18036 1.83333 3.66659 1.83333H11.9166C12.4028 1.83333 12.8691 2.02648 13.2129 2.3703C13.5568 2.71412 13.7499 3.18043 13.7499 3.66666V4.58333"
  }));
}
Copy.displayname = "Copy";
//# sourceMappingURL=Copy.js.map